import service from './request'
import md5 from 'js-md5';

// 分页查询收藏
export const favoritesList = data => {
    return service({
          url: `/share/favorites/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}`,
          method: 'get',
    })
}

// 删除收藏
export const deleteFavorites = ids => {
    return service({
          url: `/share/favorites/${ids}`,
          method: 'delete',
    })
}


// 订单列表
export const orderList = data => {
    return service({
          url: `/share/order/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}`,
          method: 'get',
    })
}


// 添加订单
export const addOrder = data => {
    return service({
          url: `/share/order`,
          method: 'post',
          data:{...data}
    })
}

// 查看数据订单详情
export const orderInfo = data => {
    return service({
          url: `/share/order/${data}/shopping-cart`,
          method: 'get'
    })
}


// 删除列表
export const deleteOrder = data => {
    return service({
          url: `/share/order/${data}`,
          method: 'delete',
    })
}

// 购物车列表
export const shoppingCart = data => {
    return service({
          url: `/share/shopping-cart/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}`,
          method: 'get',
    })
}

// 获取购物车信息
export const shoppingCartInfo = id => {
    return service({
          url: `/share/shopping-cart/${id}`,
          method: 'get',
    })
}

// 批量添加到购物车
export const addbatchShoppingCart = data => {
    return service({
          url: `/share/shopping-cart/`,
          method: 'post',
          data:{
              ...data
          }
    })
}

// 根据编号批量删除购物车信息
export const daleteBatchShoppingCart = data => {
    return service({
          url: `/share/shopping-cart/${data}`,
          method: 'delete',
      
        
    })
}


// private
export const privateData = data => {
    return service({
          url: `/share/order/stat`,
          method: 'get',
      
        
    })
}

// private
export const ftpInfo = data => {
    return service({
          url: `/share/order/ftp/${data}`,
          method: 'get',
      
        
    })
}